import { qpDecode } from '../mime-enc/qp-decode';
import { checkHisto, getStrbufSummary } from '../str-buf/getStrbufSummary';
import { isStr } from '../utils/common';
import { LeafMimeNode } from './types';

function _decodeTransferEnc(rawBody: string, transferEnc: string | undefined): Buffer {
	transferEnc = transferEnc?.toLowerCase();

	const aggs = getStrbufSummary(rawBody);
	if (!aggs.allAscii) {
		console.warn('MIME body has 8-bit values');
	}

	if (transferEnc === 'base64') {
		if (
			checkHisto(aggs.histo, 0, 9) ||
			checkHisto(aggs.histo, 11, 12) ||
			checkHisto(aggs.histo, 14, 42) ||
			checkHisto(aggs.histo, 44, 46) ||
			checkHisto(aggs.histo, 58, 60) ||
			checkHisto(aggs.histo, 62, 64) ||
			checkHisto(aggs.histo, 91, 96) ||
			checkHisto(aggs.histo, 123, 255)
		) {
			throw new Error('Got unexpected base64 bytes');
		}
		return Buffer.from(rawBody, 'base64');
	} else if (transferEnc === 'quoted-printable') {
		return qpDecode(rawBody);
	} else if (transferEnc === '7bit') {
		if (!aggs.allAscii) {
			console.warn('MIME body has 8-bit values');
		}
		return Buffer.from(rawBody, 'latin1');
	} else if (transferEnc === '8bit' || transferEnc === 'binary') {
		// We already know it is only 7bit
		return Buffer.from(rawBody, 'latin1');
	} else {
		throw new Error(`Unhandled content-transfer-encoding: ${transferEnc ?? '<undefined>'}`);
	}
}

export function decodeTransferEnc(rawBody: string, transferEnc: string | undefined): Buffer;
export function decodeTransferEnc(node: Pick<LeafMimeNode, 'rawBody' | 'transferEncoding'>): Buffer;
export function decodeTransferEnc(
	nodeOrRawBody: Pick<LeafMimeNode, 'rawBody' | 'transferEncoding'> | string,
	transferEnc?: string
): Buffer {
	const _rawBody: string = isStr(nodeOrRawBody) ? nodeOrRawBody : nodeOrRawBody.rawBody;
	const _transferEnc: string | undefined = isStr(nodeOrRawBody)
		? transferEnc
		: nodeOrRawBody.transferEncoding;

	const buf = _decodeTransferEnc(_rawBody, _transferEnc);
	return buf;
}
